import styled from 'styled-components'
// tslint:disable-next-line:max-line-length
export const Birthdate = styled.input`
  font-family: DD-TTNorms, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol';
  max-width: 100%;
  margin-top: 4px !important;
  padding: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 16px;
  line-height: 1.5;
  display: flex;
  width: 100%;
  align-items: center;
  border-radius: 4px;
  box-shadow: ${props =>
    props['data-error']
      ? `inset 0 0 0 1px #ff3008`
      : `inset 0 0 0 1px #CCCCCC`};
  border: none;
`
